"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    loadCalendarEvents: { datapoint: { name: 'LoadCalendar' } },
    loadWeatherForecast: { datapoint: { name: 'WEATHER' } },
};
//# sourceMappingURL=datapoints.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-upnext/lib/datapoints.js
// module id = 3676
// module chunks = 48